import React, { Component } from 'react';
import { List, Row, Col } from  'antd';
import { pas, pasTitle } from '../../utils/legalUtils';

export default class AfspPAS extends Component {
    render() {
        return (
            <div style={{ marginLeft: '10px', marginRight: '10px' }}>
                <div className='afsp-layout-title'>
                    {pasTitle}
                </div>
                <List
                    itemLayout='horizontal'
                    dataSource={pas}
                    renderItem={item => (
                        <List.Item>
                            <div className='afsp-layout-content-box'>
                                <Row>
                                    <Col span={24} style={{ fontWeight: 'bold' }}>
                                        <div className='afsp-layout-content-header'>
                                            {item.header}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <div className='afsp-layout-content'>
                                            {item.content}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </List.Item>
                    )}
                ></List>
            </div>
        )
    }
}
